
import BannerContainer from '~/components/child/banner/BannerContainer.vue';
import TagContainer from '~/components/child/tag/TagContainer.vue';
import RecipeContainer from '~/components/child/recipe/RecipeContainer.vue';
import BrowseContainer from '~/components/child/browse/BrowseContainer.vue';
import ArticleChannelContainer from '~/components/child/article/ArticleChannelContainer.vue';
import PopularMoive from '~/components/child/movie/PopularMoive.vue';
import BloggerRankingChannel from '~/components/child/blogger/BloggerRankingChannel.vue';
import ArticleHotContainer from '~/components/child/article/ArticleHotContainer.vue';
export default {
    name: "travel",
    components: {
            BannerContainer,
            TagContainer,
            RecipeContainer,
            BrowseContainer,
            ArticleChannelContainer,
            PopularMoive,
            BloggerRankingChannel,
            ArticleHotContainer
    },
    head() {
        return {
            title: '影視-PIXNET痞客邦',
            meta: [
                { hid: 'description', name: 'description', content: '痞客邦，影迷們交流的園地！熱愛影音的你，不可錯過！我們是一個充滿活力和激情的社群平台，專注於影音討論。在痞客邦，你可以與其他影音迷緊密連結，分享你對電影、音樂和影集的熱愛與評論！無論是經典之作、新鮮流行的作品，還是獨立電影、地下樂團，你都能在這裡找到同好。不僅如此，痞客邦還提供最新的影音消息、導演創作心得、觀影心得分享等，讓你全方位深入了解影音世界。立即加入我們的社群，與痞客邦的影音迷一同探索無限可能，開啟你的影音之旅！' },
                { hid: 'og:description', name: 'og:description', property: 'og:description', content: '痞客邦，影迷們交流的園地！熱愛影音的你，不可錯過！我們是一個充滿活力和激情的社群平台，專注於影音討論。在痞客邦，你可以與其他影音迷緊密連結，分享你對電影、音樂和影集的熱愛與評論！無論是經典之作、新鮮流行的作品，還是獨立電影、地下樂團，你都能在這裡找到同好。不僅如此，痞客邦還提供最新的影音消息、導演創作心得、觀影心得分享等，讓你全方位深入了解影音世界。立即加入我們的社群，與痞客邦的影音迷一同探索無限可能，開啟你的影音之旅！' },
                { hid: 'twitter:description', name: 'twitter:description', property: 'twitter:description', content: '痞客邦，影迷們交流的園地！熱愛影音的你，不可錯過！我們是一個充滿活力和激情的社群平台，專注於影音討論。在痞客邦，你可以與其他影音迷緊密連結，分享你對電影、音樂和影集的熱愛與評論！無論是經典之作、新鮮流行的作品，還是獨立電影、地下樂團，你都能在這裡找到同好。不僅如此，痞客邦還提供最新的影音消息、導演創作心得、觀影心得分享等，讓你全方位深入了解影音世界。立即加入我們的社群，與痞客邦的影音迷一同探索無限可能，開啟你的影音之旅！' },
                { hid: 'keywords', name: 'keywords', content: '影集，影評，劇評，Netflix，串流平台，電影,線上看,電影線上看,日本電影,台灣電影,韓國電影,歐美電影,美國電影,泰國電影,中國電影,香港電影,法國電影,印度電影,熱門電影,卡通電影,災難電影,戰爭電影,恐怖電影,動畫電影,兒童電影,迪士尼電影,國片' },
                { hid: 'og:title', name: 'og:title', property: 'og:title', content: "影視-PIXNET痞客邦"},
                { property: 'og:image', property: 'og:image', content: "https://www.pixnet.net/img/public/og/img_movie_og.png"},
                { property: 'og:image:secure_url', property: 'og:image:secure_url', content: "https://www.pixnet.net/img/public/og/img_movie_og.png"},
                { property: 'twitter:image', property: 'twitter:image', content: "https://www.pixnet.net/img/public/og/img_movie_og.png"},
                { property: 'image', name: 'image', itemprop: 'image', content: "https://www.pixnet.net/img/public/og/img_movie_og.png"},
            ],
            link: [
                { rel: 'canonical', href: 'https://www.pixnet.net/channel/movie', key: "canonical"}
            ]
        }
    },
    jsonld() {
        return {
            "@context": " https://schema.org/",
            "@graph": [
                {
                    "@context":"https://schema.org",
                    "@type":"Organization",
                    "url":"https://www.pixnet.net",
                    "logo":"https://www.pixnet.net/img/public/og/img_movie_og.png",
                    "name":"痞客邦",
                    "@id":"https://www.pixnet.net/#organization",
                    "description":"痞客邦，影迷們交流的園地！熱愛影音的你，不可錯過！我們是一個充滿活力和激情的社群平台，專注於影音討論。在痞客邦，你可以與其他影音迷緊密連結，分享你對電影、音樂和影集的熱愛與評論！無論是經典之作、新鮮流行的作品，還是獨立電影、地下樂團，你都能在這裡找到同好。不僅如此，痞客邦還提供最新的影音消息、導演創作心得、觀影心得分享等，讓你全方位深入了解影音世界。立即加入我們的社群，與痞客邦的影音迷一同探索無限可能，開啟你的影音之旅！",
                    "address":"",
                    "brand":{
                        "@type":"Brand",
                        "logo":"https://www.pixnet.net/img/public/og/img_movie_og.png"
                    },
                    "sameAs":"https://www.facebook.com/pixnet.net"
                },
                {
                    "@context":"https://schema.org/",
                    "@type":"BreadcrumbList",
                    "itemListElement":[
                        {
                            "@type": "ListItem",
                            "position": 1,
                            "name": "影視-PIXNET痞客邦",
                            "item": "https://www.pixnet.net",
                            "description": "痞客邦，影迷們交流的園地！熱愛影音的你，不可錯過！我們是一個充滿活力和激情的社群平台，專注於影音討論。在痞客邦，你可以與其他影音迷緊密連結，分享你對電影、音樂和影集的熱愛與評論！無論是經典之作、新鮮流行的作品，還是獨立電影、地下樂團，你都能在這裡找到同好。不僅如此，痞客邦還提供最新的影音消息、導演創作心得、觀影心得分享等，讓你全方位深入了解影音世界。立即加入我們的社群，與痞客邦的影音迷一同探索無限可能，開啟你的影音之旅！",
                            "keywords": "影集，影評，劇評，Netflix，串流平台，電影,線上看,電影線上看,日本電影,台灣電影,韓國電影,歐美電影,美國電影,泰國電影,中國電影,香港電影,法國電影,印度電影,熱門電影,卡通電影,災難電影,戰爭電影,恐怖電影,動畫電影,兒童電影,迪士尼電影,國片"
                        }
                    ]
                }
            ]
        }
    },
    data() {
        return {
            swiper: '',
            channel_page_id: 5,
            showAnimation: false,
            intro_link: [
                { id: 1, title: 'LiTV免費看片', sub: '與LiTV攜手打造影音好環境！', link: 'https://litv-free-video.events.pixnet.net/'},
                { id: 2, title: '痞客邦電影圈', sub: '第一手電影新訊報你知', link: 'https://movie1314.pixnet.net/coblog'},
                { id: 3, title: 'EBC影音線上看', sub: '尋找鄉鎮美食，挖掘旅行走吧充電趣！', link: 'https://ebctvdrama.events.pixnet.net/#/wassupmanletschill'},
                { id: 4, title: '靖天電視台', sub: '最新、最熱門的影視話題都在這', link: 'https://goldentvdrama.events.pixnet.net/'},
            ]
        }
    },
    computed: {
        is_login() {
            return this.$store.state.login.login_status;
        },
        tab_id() {
            return this.$store.state.channel_tab.tab_id;
        },
        tab_left() {
            return this.$store.state.channel_tab.tab_highlight_style.left;
        },
        tab_width() {
            return this.$store.state.channel_tab.tab_highlight_style.width;
        },
        window_width() {
            return this.$store.state.channel_tab.window_width;
        },
        pa_page_name() {
            return '影視';
        },
        tag_search_text() {
            return '影視';
        },
        day_hot_article() {
            return this.$store.state.article.day_hot_article;
        },
        day_hot_article_full() {
            return this.$store.state.article.day_hot_article_full;
        }
    },
    methods: {
        paFunction() {
            window._piq.push(['trackEvent', 'rs2022::十大頻道::' + this.pa_page_name, 'imps::頁面::page::user_action', '', '']);
        },
        paScrollFunction(){
            addEventListener("scroll", () => {
                window._piq.push(['trackEvent', 'rs2022::十大頻道::' + this.pa_page_name, 'scroll::頁面::page::user_action', '', '']);
            }, { once: true });
        },
        paAnchorFunction() {
            this.intro_link.forEach((e, index) => {
                let reg_link = e.link.replace('https://', 'http://');
                window._piq.push(['trackEvent', 'rs2022::十大頻道::' + this.pa_page_name, 'imps::導流入口::anchor::movie_related', e.title + '::' + reg_link, 1 + (index + 1)/10000]);
            });
        },
        paClickAnchorFunction(item) {
            let reg_link = item.link.replace('https://', 'http://');
            window._piq.push(['trackEvent', 'rs2022::十大頻道::' + this.pa_page_name, 'click::導流入口::anchor::movie_related', item.title + '::' + reg_link, 1 + item.id/10000]);
        },
        gtag(){
            window.dataLayer.push(arguments);
        },
        activeGaPage() {
            this.gtag('config', 'G-RPGK0ML6QM', {
                'channel_category': '影視'
            });
            this.gtag('config', 'G-45SMZ66RLZ', {
                'channel_category': '影視'
            });
            this.gtag('event', 'page_view', {
                page_title: '影視-PIXNET痞客邦',
            });
        },
        activeMcPage() {
            (function(c,l,a,r,i,t,y){
                c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", "kbvat69or6");
        },
    },
    async fetch(){
        const item = { sort: 'hot', type: 'group', pre_page: 10, id: this.channel_page_id, ver: 2 }
        await this.$store.dispatch("article/getDayHotArticle", item);
    },
    mounted() {
        window.dataLayer = window.dataLayer || [];
        this.activeGaPage();
        this.activeMcPage();
        this.paFunction();
        this.paScrollFunction();
        this.paAnchorFunction();
    }
}
